<template>
  <div style="width: 100%;min-width: 1200px;">
    <img src="../assets/images/home/banner5.jpg" alt="" style="width: 100%">

    <!--	通知公告/大赛简介-->
    <div class="container">
      <div class="row" style="position: relative;width: calc(100% + 15px);display: inline-block;">
        <img src="../assets/images/home/01notice.png" alt="" class="titleImg">
            <dl class="news_dl_side" style="margin-bottom: 0px!important">
              <dd v-for="datatype in this.newsNotice1">
                <span class="spanNumber">{{datatype.sourceFrom}}</span>
                <span class="spanTitle" :title="datatype.title" @click="hotInform(datatype.id)">{{datatype.title}}</span>
                <span class="news_date">{{datatype.issueTime}}</span>
                <!--              <span class="news_date">2021-04-25</span>-->
              </dd>
              <dd>
                <a href="javascript:void(0)" @click="viewMore()" style="float: right">查看更多 >></a>
              </dd>
            </dl>

      </div>
    </div>

    <!--参赛对象-->
    <div class="container">
      <div class="row" style="position: relative">
        <div class="col-sm-12" style="overflow: hidden;margin-top: 30px;">
          <img src="../assets/images/home/02Participants.png" alt="" class="titleImg">
          <p style="font-size: 17px;text-align:center;line-height: 30px;padding-top: 5px;margin-bottom: 5px;text-align: center">&emsp;（*本活动全程不向参赛者收取任何费用，现场答辩环节差旅自理。）</p>

        </div>
<!--        <div class="col-sm-4" style="overflow: hidden;margin-top: 30px;">-->
<!--          <img src="../assets/images/home/001.jpg" alt="" style="width: 100%;">-->
<!--        </div>-->
        <div class="col-sm-12" style="overflow: hidden;position: relative">
<!--          <div class="introduction_card" style="display: inline-block;background: transparent;">-->
<!--            <p style="font-size: 16px;line-height: 45px;padding-top: 60px">&emsp;&emsp;高校在校本科生、硕士研究生以及博士研究生均可组队报名。每参赛团队学生不多于6人，指导教师不多于2人，-->
<!--              成员学历构成不限；自拟赛队名称，并指定联系人。每位学生仅限参与1支团队、每位指导教师最多指导2支队伍</p>-->
<!--            <div style="height: 25px;width: 100%;display: inline-block"></div>-->
            <img src="../assets/images/home/csdx.png" alt="" style="width: 100%;">
          <div style="position: absolute;right: 200px;bottom: 80px;">
          <p class="csdxP"><span></span>自拟赛队名称，并指定联系人。</p>
          <p class="csdxP"><span></span>高校在校本科生、硕士研究生以及博士研究生均可组队报名。</p>
          <p class="csdxP"><span></span>每参赛团队学生不多于6人，指导教师不多于2人，学历不限。</p>
          <p class="csdxP"><span></span>每位学生仅限参与1支团队、每位指导教师最多指导2支队伍。</p>
          </div>

          <!--          </div>-->
        </div>
      </div>
    </div>

    <!--比赛主题-->
    <div class="container">
      <div class="row" style="position: relative">
        <div class="col-sm-12" style="overflow: hidden;margin-top: 30px;">
          <img src="../assets/images/home/03theme.png" alt="" class="titleImg">
        </div>
        <div class="col-sm-12" style="overflow: hidden">
          <div class="introduction_card" style="display: inline-block;background: transparent;">
            <p style="font-size: 17px;line-height: 30px;padding-top: 5px;margin-bottom: 5px;">&emsp;&emsp;大赛接受以下领域的科研作品参赛，鼓励广泛利用各类数据开展实证分析，鼓励将生态环境科学技术应用于城市规划、产业规划、生产技术优化等领域的跨界应用研究。</p>
            <!--<table class="theamTable">
              <tr>
                <td><span></span>社会-经济-自然复合生态系统模拟</td>
                <td><span></span>生态系统功能、过程与服务</td>
              </tr>
              <tr>
                <td><span></span>生态可持续发展</td>
                <td><span></span>生态系统保护与修复</td>
              </tr>
              <tr>
                <td><span></span>生态系统健康</td>
                <td><span></span>生态系统韧性</td>
              </tr>
              <tr>
                <td><span></span>生态承载力</td>
                <td><span></span>生态环境治理</td>
              </tr>
              <tr>
                <td><span></span>生态资源保护与管理</td>
                <td><span></span>生态环境要素代谢模拟</td>
              </tr>
              <tr>
                <td><span></span>生态环境与气候变化</td>
                <td><span></span>生态经济核算</td>
              </tr>
              <tr>
                <td><span></span>产业生态与循环经济</td>
                <td><span></span>生态环境管理政策</td>
              </tr>
              <tr>
                <td><span></span>生态环境与可持续发展目标</td>
                <td><span></span>生态环境大数据与应用</td>
              </tr>
            </table>-->
            <img src="../assets/images/home/theme_new.png" style="width: 100%"/>
            <div style="height: 25px;width: 100%;display: inline-block"></div>
          </div>
        </div>
      </div>
    </div>

    <!--	时间节点-->
    <div class="container">
      <div class="row">
        <img src="../assets/images/home/04schedule.png" alt="" class="titleImg">
        <!-- <p style="font-size: 17px;text-align:center;line-height: 30px;padding-top: 5px;margin-bottom: 5px;text-align: center">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;（*因疫情防控等原因可能对时间造成影响，具体时间以最新通知为准，请关注本网站及底部比赛官方宣传平台。）</p> -->
        <div class="col-sm-12" style="overflow: hidden">
<!--          <img src="../assets/images/home/step.png" alt="" style="width: 100%;">-->
          <img src="../assets/images/home/schedulePic_new_2.png" alt="" style="width: 100% ;margin-bottom: 25px">
        </div>
      </div>
    </div>

    <!--大礼包-->
    <!--<div class="container">
      <div class="row" style="position: relative">
        <div class="col-sm-12" style="overflow: hidden;margin-top: 30px;">
          <img src="../assets/images/home/dalibao.png" alt="" class="titleImg">
        </div>
        <p style="font-size: 17px;text-align:center;line-height: 30px;padding-top: 5px;margin-bottom: 5px;text-align: center">&emsp;（*报名队伍通过初选后有机会获得以下参赛礼包，大赛组委会将于2021年11月3日至12日间组织礼包在线说明会，请大家关注网页底部公众号。）</p>
        <img src="../assets/images/home/gift.png" class="giftPic" style="width: 100%"/>
        <div style="height: 70px;width: 100%;display: inline-block"></div>
      </div>
    </div>-->

    <!--生态管理回顾-->
    <div class="container">
      <div class="row">
        <img src="../assets/images/home/07lookback.png" alt="" class="titleImg">
        <div class="col-sm-12" style="overflow: hidden;overflow-x: auto;">
          <div class="wrapper-content">
            <div class="wrapper">
              <div class="box blury-card">
                <a href="http://www.ricem.cn/#/hot_inform?id=f131f99c-f2ee-4853-b990-9ced9d167236" target="_blank">
                <img src="../assets/images/home/lb8.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="https://www.ricem.cn/#/hot_inform?id=bd091f2c-803d-4d4a-9416-9a9a7ea42714" target="_blank">
                <img src="../assets/images/home/lb10.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)"  @click="cardHref()"><!--target="_blank"-->
                <img src="../assets/images/home/lb1.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb2.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb3.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <!-- 第四届论文大赛--林芝 -->
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb9.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb4.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb5.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb6.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
            <div class="wrapper">
              <div class="box blury-card">
                <a href="javascript:void(0)" @click="cardHref()">
                <img src="../assets/images/home/lb7.png" alt="Blue Ridge Mountains">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 参与单位 -->
    <div class="cupWrapper" :style="'margin-top:80px;'">
      <div class="Relatedness" style="position: relative;padding-bottom: 60px">
        <img src="../assets/images/home/wspic.png" alt="" style="position: absolute;bottom: 0;right: 0;width: 30%">
        <div class="container">
          <div class="row">
            <img src="../assets/images/home/canyudanwei.png" alt="" class="titleImg">
            <!-- <table class="committeeTable">
              <tr>
                <td colspan="3">中国生态学学会生态管理专委会&emsp;青年工作委员会&emsp;教育工作委员会</td>
              </tr>
              <tr>
                <td colspan="2"><span>协办单位（持续更新）</span></td>
                <td></td>
              </tr>
              <tr>
                <td colspan="3">广联达科技股份公司&emsp;航天五院508所&emsp;深圳航天东方红卫星有限公司&emsp;中科绿色发展（北京）信息技术有限公司&emsp;E方知库期刊群&emsp;科萤书院</td>
              </tr>
            </table> -->
            <!-- 原来有个50px的top间距，先注释了 -->
            <div style="width: 100%;padding: 15px 30px;text-align: justify;">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/1.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/2.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/3.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/4.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/5.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/6.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/7.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/8.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/9.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/10.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/11.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/12.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/13.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/14.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/15.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/16.jpg" alt="">
              <img class="companyLogo" src="../assets/images/home/companyLogo-f/17.jpg" alt="">
            </div>

            <!--顾问委员会-->
            <!--<img src="../assets/images/home/05committee.png" alt="" class="titleImg">
            <p style="width: 100%;text-align: center;font-size: 12px;color: #fff;;position: relative;top: -45px">（按姓名拼音排序）</p>
            <table class="committeeTable">
              <tr>
                <td><span>毕&emsp;军</span>复旦大学</td>
                <td><span>陈冠益</span>天津大学</td>
                <td><span>陈&nbsp;诗&nbsp;一</span>&nbsp;复旦大学</td>
              </tr>
              <tr>
                <td><span>陈晓红</span>湖南工商大学</td>
                <td><span>仇焕广</span>中国人民大学</td>
                <td><span>邓&nbsp;祥&nbsp;征</span>&nbsp;中国科学院地理科学与资源研究所</td>
              </tr>
              <tr>
                <td><span>冯奎双</span>University of Maryland</td>
                <td><span>耿&emsp;涌</span>上海交通大学</td>
                <td><span>关&nbsp;大&nbsp;博</span>&nbsp;清华大学</td>
              </tr>
              <tr>
                <td><span>郝吉明</span>清华大学</td>
                <td><span>李善同</span>国务院发展研究中心</td>
                <td><span>刘&emsp;&emsp;合</span>中国石油勘探开发研究院</td>
              </tr>
              <tr>
                <td><span>刘晓龙</span>中国工程院</td>
                <td><span>鲁&emsp;玺</span>清华大学</td>
                <td><span>欧阳志云</span>中国科学院生态环境研究中心</td>
              </tr>
              <tr>
                <td><span>齐&emsp;晔</span>清华大学</td>
                <td><span>石敏俊</span>浙江大学</td>
                <td><span>司&emsp;&emsp;伟</span>中国农业大学</td>
              </tr>
              <tr>
                <td><span>王&emsp;浩</span>中国水利水电科学研究院</td>
                <td><span>王&emsp;强</span>北京林业大学</td>
                <td><span>王&nbsp;兆&nbsp;华</span>&nbsp;北京理工大学</td>
              </tr>
              <tr>
                <td><span>魏一鸣</span>北京理工大学</td>
                <td><span>温宗国</span>清华大学</td>
                <td><span>吴&emsp;&emsp;刚</span>国家自然科学基金委员会</td>
              </tr>
              <tr>
                <td><span>徐&emsp;明</span>University of Michigan</td>
                <td><span>杨列勋</span>国家自然科学基金委员会</td>
                <td><span>杨&nbsp;晓&nbsp;光</span>&nbsp;中国科学院数学与系统科学研究院</td>
              </tr>
              <tr>
                <td><span>杨志峰</span>广东工业大学</td>
                <td><span>岳天祥</span>&nbsp;中国科学院地理科学与资源研究所</td>
                <td><span>张&emsp;&emsp;炳</span>南京大学</td>
              </tr>
              <tr>
                <td><span>张跃军</span>湖南大学</td>
                <td><span>赵景柱</span>中国科学院城市环境研究所</td>
                <td><span>郑&emsp;&emsp;华</span>中科院生态环境研究中心</td>
              </tr>
            </table>-->

            <!--大赛组委会-->
            <!--<img src="../assets/images/home/06organizer.png" alt="" class="titleImg">
            <p style="width: 100%;text-align: center;font-size: 12px;color: #fff;;position: relative;top: -45px">（按姓名拼音排序）</p>
            <table class="committeeTable1" style="margin-bottom: 80px;">
              <tr>
                <td style="width: 120px;vertical-align: initial;">主&emsp;&emsp;任：</td>
                <td colspan="3"><span>陈&emsp;彬</span>北京师范大学</td>
              </tr>
              <tr>
                <td rowspan="13" style="width: 120px;vertical-align: initial;">组委会成员：</td>
                <td><span>蔡博峰</span>生态环境部环境规划院</td>
                <td><span>蔡永立</span>上海交通大学</td>
                <td><span>陈绍晴</span>中山大学</td>
                </tr>
              <tr>
                <td><span>陈伟强</span>中国科学院城市环境研究所</td>
                <td><span>陈占明</span>中国人民大学</td>
                <td><span>程&emsp;胜</span>中国地质大学(武汉)</td>
              </tr>
              <tr>
                <td><span>戴瀚程</span>北京大学</td>
                <td><span>杜慧滨</span>天津大学</td>
                <td><span>方&emsp;恺</span>浙江大学</td>
              </tr>
              <tr>
                <td> <span>葛建平</span>中国地质大学（北京）</td>
                <td><span>胡&emsp;毅</span>中国科学院大学</td>
                <td><span>孔红梅</span>《生态学报》编辑部</td>
              </tr>
              <tr>
                <td><span>李&emsp;栋</span>清华大学</td>
                <td><span>李佳硕</span>山东大学</td>
                <td><span>李&emsp;琳</span>《系统工程理论与实践》编辑部</td>
              </tr>
              <tr>
                <td><span>刘耕源</span>北京师范大学</td>
                <td><span>刘红晓</span>中国科学院华南植物园</td>
                <td><span>刘兰翠</span>北京师范大学</td>
              </tr>
              <tr>
                <td><span>卢中铭</span>香港科技大学</td>
                <td><span>陆宏芳</span>中国科学院华南植物园</td>
                <td><span>逯&emsp;非</span>中国科学院生态环境研究中心</td>
              </tr>
              <tr>
                <td><span>罗巧玲</span>武汉大学</td>
                <td><span>任宗明</span>山东师范大学</td>
                <td><span>孙芳芳</span>深圳市环境科学研究院</td>
              </tr>
              <tr>
                <td><span>汤&emsp;玲</span>北京航空航天大学</td>
                <td><span>唐立娜</span>中国科学院城市环境研究所</td>
                <td><span>唐&emsp;旭</span>中国石油大学（北京）</td>
              </tr>
              <tr>
                <td><span>王玉涛</span>复旦大学</td>
                <td><span>吴&emsp;锋</span>中国科学院地理科学与资源研究所</td>
                <td><span>吴三忙</span>中国地质大学（北京）</td>
              </tr>
              <tr>
                <td><span>夏晓华</span>中国人民大学</td>
                <td><span>谢&emsp;杨</span>北京航空航天大学</td>
                <td><span>徐卫华</span>中国科学院生态环境研究中心</td>
              </tr>
              <tr>
                <td><span>杨&emsp;谨</span>中国地质大学（北京）</td>
                <td><span>杨庆周</span>中科绿色发展(北京)信息技术有限公司</td>
                <td><span>张&emsp;博</span>中国矿业大学（北京）</td>
              </tr>
              <tr>
                <td><span>张力小</span>北京师范大学</td>
                <td><span>张&emsp;宁</span>山东大学</td>
                <td><span>张&emsp;倩</span>中国农业大学</td>
              </tr>
              <tr>
                <td style="width: 120px;vertical-align: initial;">秘&nbsp;书&nbsp;&nbsp;长：</td>
                <td colspan="3">
                  <span>韩宝龙</span> 中国科学院生态环境研究中心</td>
              </tr>
              <tr>
                <td rowspan="2" style="width: 120px;vertical-align: initial;">副秘书长：</td>
                <td>
                  <span>房德琳</span> 北京师范大学</td>
                <td>
                  <span>王赛鸽</span> 北京师范大学</td>
                <td>
                  <span>夏楚瑜</span> 北京师范大学</td>
              </tr>
              <tr>
                <td>
                  <span>蔡文博</span> 中国科学院生态环境研究中心</td>
              </tr>
            </table>-->

          </div>
        </div>
      </div>
    </div>


    <!--	联系我们-->
    <div class="container" style="margin-bottom: 35px">
      <div class="row">
        <div class="col-sm-12">
        <img src="../assets/images/home/08contact.png" alt="" class="titleImg">
        </div>
        <div class="col-sm-7" style="padding: 5px 0 5px 0;">
          <div class="infor" style="height: auto;width: 100%;">
<!--            <p>通信地址：&nbsp;&nbsp;<span>北京市海淀区新街口外大街19号，北京师范大学，100875(邮编)</span></p>-->
            <p>咨询邮箱：&nbsp;&nbsp;<span>刘老师&nbsp;,&nbsp;zfliu@rcees.ac.cn</span></p>
<!--            <p>联系电话：&nbsp;&nbsp;<span></span></p>-->
            <p>大赛网址：&nbsp;&nbsp;<span>https://www.ricem.cn/</span>
            </p>
<!--            <p>大赛邮箱：&nbsp;&nbsp;<span>ricem_office@163.com</span></p>-->
<!--            <p>二&nbsp;维&nbsp;&nbsp;码：&nbsp;&nbsp;<span>-->
<!--              <img src="../assets/images/home/qrcode.png" alt="Blue Ridge Mountains"-->
<!--                   style="height: 80px;width: 80px;background-color: #fff;padding: 5px;vertical-align: top;">-->
<!--            </span></p>-->

          </div>
        </div>
        <div class="col-sm-5" style="overflow: hidden;position: relative">
          <!-- <iframe src="../../static/baidumap.html" frameborder="0" class="mapFrame"></iframe>-->
          <img src="../assets/images/home/qrcode.png" alt="Blue Ridge Mountains" style="image-rendering: -webkit-optimize-contrast!important;height:170px;margin: 8px;float: right">
<!--          <p style="position: absolute;bottom: 5px;width: 100px;text-align: center;right: 0">扫码立即关注</p>-->
        </div>

      </div>
    </div>

    <!--	footer-->
    <div style="background-color: #161816;height: 50px">
      <p style="font-size: 12px;line-height: 50px;color:#eee;width: 100%;text-align: center;margin: 0;">
        <!--中国生态学学会 版权所有  |-->
        <!--<a href="http://www.sgd.ac.cn/" target="_blank" class="bottomHref">-->中科绿色发展（北京）信息技术有限公司
        技术支持<!--</a>-->  |    <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备20013273号-6</a>
      </p>
    </div>
  </div>
</template>

<script>
  import '../assets/css/main.css'
  import 'bootstrap/dist/css/bootstrap.min.css'
  import 'bootstrap/dist/js/bootstrap.min.js'
  import {mapState} from "vuex";
  import {dateStr2Times} from '../util/TimeTransition'

  export default {
    name: 'home',
    computed: mapState([
      'newsNotice1'
    ]),
    data() {
      return {
        index: 1
      }
    },
    methods: {
      /**
       * 点击热点新闻
       */
      hotInform(id) {
        let routeUrl = this.$router.resolve({
          path: '/hot_inform?id=' + id,
        });
        window.open(routeUrl.href, '_blank');
      },
      /**
       * 卡片跳转
       */
       cardHref() {
        let id = "0dd9a9b4-3d69-4820-aef1-6dc8d0723e61"
        let routeUrl = this.$router.resolve({
          path: '/hot_inform?id=' + id,
        });
        window.open(routeUrl.href, '_blank');
       },

      /**
       * 大赛论文排版格式
       */
      layoutDesigner() {
        let routeUrl = this.$router.resolve({
          path: '/layout_designer',
        });
        window.open(routeUrl.href, '_blank');
      },

      /**
       * 查看详情
       */
      viewDetails() {
        /*let routeUrl = this.$router.resolve({
          path: '/view_details',
        });*/
        let id = '3'
        let routeUrl = this.$router.resolve({
          path: '/hot_inform?id=' + id,
        });
        window.open(routeUrl.href, '_blank');
      },

      /**
       *查看更多
       */
      viewMore() {
        let routeUrl = this.$router.resolve({
          path: '/view_more',
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    watch: {
       newsNotice1: function () {
         /*let notice = this.newsNotice
         for (let i = 0; i < notice.length; i++) {
           notice[i].index = i+2
           notice[i].issueTime = dateStr2Times(notice[i].issueTime)
         }*/
        /* let notice = this.newsNotice1
         for (let i = 0; i < notice.length; i++) {
           notice[i].sourceFrom = i + 1
           notice[i].issueTime = dateStr2Times(notice[i].issueTime)
         }*/
       }
    },
    created() {
     /* let notice = this.newsNotice1
      for (let i = 0; i < notice.length; i++) {
        notice[i].sourceFrom = i + 1
        notice[i].issueTime = dateStr2Times(notice[i].issueTime)
      }*/
    }
  }
</script>
<style scoped>
  .bottomHref {
    color: white;
    border-bottom: 1px solid #fff;
  }

  .bottomHref:hover {
    text-decoration: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/Home.vue